import { FaRegEdit } from "react-icons/fa"
import { RiDeleteBinFill } from "react-icons/ri"
import { listaEstadosActivo, listaTipoModulo } from "../../../app/constants/constants-selectores"
import { obtenerLabel } from "../../../shared/utils/funciones"
import { TablaSkeleton } from "../../../shared/ui/TablaSkeleton";

// Props presentacionales; la lógica vive en ModulosPage. Los handlers se tipan
// laxo (`any`) por pragmatismo en la migración.
interface ModulosTablaProps {
  isLoading: boolean;
  listaModulos: any[];
  buscar: boolean;
  mostrarBotonEditar: boolean;
  mostrarBotonEliminar: boolean;
  moduloListarSubModulos: (...args: any[]) => any;
  moduloEditar: (...args: any[]) => any;
  moduloEliminar: (...args: any[]) => any;
}

// Tabla de resultados de la página Módulos (sólo JSX presentacional).
export const ModulosTabla = ({
  isLoading,
  listaModulos,
  buscar,
  mostrarBotonEditar,
  mostrarBotonEliminar,
  moduloListarSubModulos,
  moduloEditar,
  moduloEliminar,
}: ModulosTablaProps) => {
  return (
        <div className="tw-mt-2 tw-rounded-2xl tw-bg-white tw-p-3 tw-shadow-md tw-border tw-border-gray-100 tw-overflow-x-auto">
          <table className="table table-hover tw-mb-0">
            <thead className="table-light">
              <tr>
                <th scope="col" className="col text-center">Código</th>
                {/* <th scope="col" className="col text-center">Orden</th> */}
                <th scope="col" className="col text-center">Módulo</th>
                <th scope="col" className="col text-center">Tipo</th>
                <th scope="col" className="col text-center">Cod Programa</th>
                <th scope="col" className="col text-center">Estado</th>
                {
                  mostrarBotonEditar && (
                    <th scope="col" className="col text-center">Editar</th>
                  )
                }
                {
                  mostrarBotonEliminar && (
                    <th scope="col" className="col text-center">Eliminar</th>
                  )
                }
              </tr>
            </thead>
            <tbody className={isLoading ? "" : "tabla-fade-in"}>
              {
                (isLoading && !listaModulos?.length) ? (
                  <TablaSkeleton rows={6} cols={6} />

                ) : (
                  listaModulos?.length > 0 ? listaModulos.map((m, index) => (
                    <tr key={m?.ModCod} className="align-middle">
                      <td>{m?.ModCod}</td>
                      {/* <td className="col-1">
                        <input
                          {...registerOrdenar(`modulosOrdenados.${index}.orden`)}
                          defaultValue={index + 1}
                          type="text"
                          className="form-control form-control-sm text-center"
                          autoComplete="off"
                        />
                      </td> */}
                      {/* Drill-down EN SITIO (estado): botón-enlace, sin <Link> (no navega). */}
                      <td><button type="button" className="btn btn-link p-0 text-decoration-none" onClick={() => moduloListarSubModulos(m?.ModCod, m?.ModDesc, m?.ModComp)}>{m?.ModDesc}</button></td>
                      <td>{obtenerLabel(listaTipoModulo, m?.ModTip)}</td>
                      <td>{m?.ModCodProg}</td>
                      <td>{m?.ModEst === "M" ? "Master" : obtenerLabel(listaEstadosActivo, m?.ModEst)}</td>
                      {
                        mostrarBotonEditar && (
                          <td><FaRegEdit size={23} cursor={'pointer'} className="color-iconos" onClick={() => moduloEditar(m?.ModCod)} /></td>
                        )
                      }
                      {
                        mostrarBotonEliminar && (
                          <td><RiDeleteBinFill size={23} cursor={'pointer'} color="#C0392B" onClick={() => moduloEliminar(m?.ModCod, m?.ModDesc)} /></td>
                        )
                      }

                    </tr>
                  )) :
                    (
                      (buscar) ? (
                        <tr>
                          <td colSpan={100} className="text-center">No hay módulos</td>
                        </tr>
                      ) : (
                        <tr>
                          <td colSpan={100} className="text-center">Realice una búsqueda</td>
                        </tr>
                      )
                    )
                )
              }
            </tbody>
          </table>
        </div>
  )
}
